<template>
  <div class="wrapper wrapper-content white-bg">
    <div class="ibox-content" style="direction: rtl">
      <div class="row">
        <!-- <div class="col-sm-6">
          <h5>From:</h5>
          <address>
            <strong>Inspinia, Inc.</strong><br />
            106 Jorg Avenu, 600/10<br />
            Chicago, VT 32456<br />
            <abbr title="Phone">P:</abbr> (123) 601-4590
          </address>
        </div> -->

        <div class="col-sm-4 text-right">
          <p>
            <span>
              شماره سفارش :
            </span>
            <span class="text-navy">{{ order.tracking_code }} </span>
          </p>
          <p>
            <span>
              تاریخ ثبت سفارش
            </span>
            <span> {{ $getJalaliDate(order.created_at) }}</span>
          </p>
        </div>
        <div class="col-sm-4"></div>
        <div class="col-sm-4 text-right ">
          <img :src="settings.factor_logo" />
        </div>
      </div>
      <hr />
      <div class="col-sm-12 text-right">
        <div class="d-flex bd-highlight">
          <div class="p-2 flex-fill bd-highlight">
            <p>
              <strong> نام و نام خانوادگی  </strong
              ><span>{{ order.full_name }}</span>
            </p>
            <p>
              <strong>کد پستی</strong><span>{{ order.postal_code }}</span>
            </p>
            <p>
              <strong> نشانی </strong
              ><span
                >{{ order.province }}،{{ order.city }}،{{ order.address }}</span
              >
            </p>
            <p>
              <strong>روش پرداخت - </strong>
              <span>
                کیف پول: {{ $thousandSeprator(order.wallet_payed) }}
              </span>
              <span v-if="parseInt(order.wallet_payed) && parseInt(order.online_payed)">
                +
              </span>
              <span v-if="parseInt(order.online_payed)">
                {{ order.paymethod.title }} :
                {{ $thousandSeprator(order.online_payed) }}</span
              >
            </p>
          </div>
          <div class="p-2 flex-fill bd-highlight">
            <p>
              <strong> ایمیل </strong><span>{{ order.email }}</span>
            </p>
            <p>
              <strong>شماره تماس</strong><span>{{ order.mobile }}</span>
            </p>
            <br />
            <p v-if="order.shipping">
              <strong> روش ارسال </strong
              ><span
                >{{ order.shipping.name }}
                {{ order.shipping_post_paid ? "(پس کرایه)" : "" }}</span
              >
            </p>
          </div>
        </div>
      </div>
      <hr />

      <div class="table-responsive m-t k-rtl" style="text-align: right">
        <table class="table invoice-table">
          <thead>
            <tr>
              <th>نام محصول</th>
              <th>کد محصول</th>
              <th>قیمت واحد(تومان)</th>
              <th>تعداد</th>
              <th>مبلغ کل(تومان)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in order.items" :key="index">
              <td>
                <div>
                  <strong
                    >{{ item.product.name }} <br />
                    <small>{{ item.combination_text }}</small></strong
                  >
                </div>
                <!-- <small>{{ item.product_price.title }}</small> -->
              </td>
              <td>{{ item.code ? item.code : "-" }}</td>
              <td>{{ $thousandSeprator(item.price) }}</td>
              <td width="110">{{ item.count }}</td>
              <td>{{ $thousandSeprator(item.payable_price * item.count) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3"></td>
              <td><strong>جمع کل :</strong></td>
              <td>{{ $thousandSeprator(order.total) }}</td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td><strong>تخفیف های حراجی :</strong></td>
              <td>{{ $thousandSeprator(order.discount) }}</td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td><strong>سایر تخفیف ها</strong></td>
              <td>{{ $thousandSeprator(order.shipping_price) }}</td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td><strong>هزینه حمل :</strong></td>
              <td>{{ $thousandSeprator(order.coupon_price) }}</td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td><strong>مبلغ نهایی سفارش :</strong></td>
              <td>{{ $thousandSeprator(order.payable) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <hr style="margin:0" />
      <div class="col-sm-12" dir="rtl" style="text-align:right">
        <h3>{{ settings.title }}</h3>
        <h3>
          {{ settings.address }} ، کد پستی {{ settings.postal_code }} -
          {{ settings.tel }}
        </h3>
        <div class="socials">
          {{settings.label_footer}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { orderApi, dashboardApi, socialMediaApi } from "@/api/apiManagement";
export default {
  data() {
    return {
      order: {},
      settings: {},
      socialMedias: [],
      baseUrl: process.env.VUE_APP_API_BASEPOINT,
    };
  },
  async mounted() {
    this.$setLayout("simple-layout");
    this.$setIsLoading(true);
    const setting = await this.loadSetting();
    const socialMedias = await this.loadSocials();
    this.settings = setting.data.settings;
    this.socialMedias = socialMedias.data.entity;
    await this.loadOrder();
    this.$setIsLoading(false);
    this.$nextTick().then(function() {
      setTimeout(window.print, 2000);
    });
  },
  methods: {
    loadSetting() {
      return dashboardApi.getInfo();
    },
    loadSocials() {
      return socialMediaApi.getSocialMedias();
    },
    loadOrder() {
      let orderID = this.$route.params.id;
      return orderApi.findOrder(orderID).then((res) => {
        this.order = res.data;
      });
    },
  },
};
</script>
<style>
body {
  background-color: #fff !important;
}
@media print {
  @page {
    size: landscape;
  }
}
</style>
<style scoped>
.socials span {
  font-size: 15px;
  margin-left: 5px;
}
.socials span::after {
  content: "-";
}
.socials span:last-child::after {
  content: "";
}
img {
  width: 127px;
}
p {
  margin-bottom: 0.1rem;
}
tr {
  font-size: 10px;
}
ul li {
  list-style: none;
  font-weight: 500;
}
.title strong {
  font-weight: 700;
}
.socials p {
  line-height: 3px;
  font-weight: 3000;
}
tfoot td:nth-child(2),
tfoot td:nth-child(1) {
  border-top: none;
}
</style>
